import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendGuaranteeQuery = () => {
  return useMutation({
    mutationFn: async () => {
      const result = await apiClient.declarant.sendGuaranteeQuery.mutation({ body: {} });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('Guarantee query was sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the Guarantee query!`);
    },
  });
};
